import { takeEvery, takeLatest, delay } from 'redux-saga'
import { call, put, select, all } from 'redux-saga/effects'

import actionTypes from 'redux/actions/actionTypes'
import { processingSelectors } from 'redux/selectors'
import { iconSync } from 'sync'
import callAny from './helpers/call_any'
import iconTypes from 'helpers/enums/iconTypes'
import processingActions from 'redux/actions/processingActions'

function *processingInitialize(action) {
	try {
		const response = yield callAny(iconSync.getPendingIcons, action.data.id)
		yield put(processingActions.processingInitializeSuccess(response.payload.icons))
	} catch (error) {
		yield put(processingActions.processingInitializeError())
	}
}

function *iconsPollingStatus() {
	try {
		let pendingIconsSelector = yield select(processingSelectors.pendingIconsSelector)
		let response
		while (pendingIconsSelector.icons.length > 0) {
			yield call(delay, 2000)
			response = yield callAny(iconSync.getIcons, pendingIconsSelector.icons)
			yield all(response.payload.icons.map(icon => call(handleIconStatus, icon)))
			pendingIconsSelector = yield select(processingSelectors.pendingIconsSelector)
		}
	} catch (error) {
		//handle error case
	}
}

function *handleIconStatus(icon) {
	if (icon.status === iconTypes.ICON_STATUS_DONE) {
		yield put(processingActions.processingIconSuccess(icon))

	} else if (icon.status === iconTypes.ICON_STATUS_ERROR) {
		yield put(processingActions.processingIconError(icon))
	}
}

export default [
	takeLatest([
		actionTypes.DRAW_IT_INITIALIZE_SUCCESS,
		actionTypes.QUIZ_INITIALIZE_SUCCESS,
		actionTypes.POLL_INITIALIZE_SUCCESS,
		actionTypes.OEQ_INITIALIZE_SUCCESS,
	], processingInitialize),
	takeEvery([actionTypes.PROCESSING_INITIALIZE_SUCCESS], iconsPollingStatus),
	takeLatest([
		actionTypes.QUIZ_UPLOADER_UPLOAD_SUCCESS,
		actionTypes.DRAW_IT_UPLOADER_UPLOAD_SUCCESS,
		actionTypes.POLL_UPLOADER_UPLOAD_SUCCESS,
		actionTypes.OEQ_UPLOADER_UPLOAD_SUCCESS,
		actionTypes.GOOGLE_SLIDES_ACTIVITY_SAVED_FINISHED,
	], iconsPollingStatus
	),
]
